export enum AWSRegionDisplayName {
  ASIA_PACIFIC_MUMBAI = 'Asia Pacific (Mumbai)',
  ASIA_PACIFIC_OSAKA = 'Asia Pacific (Osaka)',
  ASIA_PACIFIC_SEOUL = 'Asia Pacific (Seoul)',
  ASIA_PACIFIC_SYDNEY = 'Asia Pacific (Sydney)',
  ASIA_PACIFIC_TOKYO = 'Asia Pacific (Tokyo)',
  CANADA_CENTRAL = 'Canada (Central)',
  EUROPE_FRANKFURT = 'Europe (Frankfurt)',
  EUROPE_IRELAND = 'Europe (Ireland)',
  EUROPE_LONDON = 'Europe (London)',
  EUROPE_ZURICH = 'Europe (Zurich)',
  MIDDLE_EAST_UAE = 'Middle East (UAE)',
  SOUTH_AMERICA_SAO_PAULO = 'South America (Sao Paulo)',
  US_EAST_NORTH_VIRGINIA = 'US East (N. Virginia)',
  US_EAST_2_OHIO = 'US East 2 (Ohio)',
  US_WEST_OREGON = 'Americas (US West)',
}

export enum AWSGenericRegionName {
  ASIA_PACIFIC_MUMBAI = 'Asia Pacific',
  ASIA_PACIFIC_OSAKA = 'Asia Pacific',
  ASIA_PACIFIC_SEOUL = 'Asia Pacific',
  ASIA_PACIFIC_SYDNEY = 'Asia Pacific',
  ASIA_PACIFIC_TOKYO = 'Asia Pacific',
  CANADA_CENTRAL = 'Americas',
  EUROPE_FRANKFURT = 'EMEA',
  EUROPE_IRELAND = 'EMEA',
  EUROPE_LONDON = 'EMEA',
  EUROPE_ZURICH = 'EMEA',
  MIDDLE_EAST_UAE = 'EMEA',
  SOUTH_AMERICA_SAO_PAULO = 'Americas',
  US_EAST_NORTH_VIRGINIA = 'Americas',
  US_EAST_2_OHIO = 'Americas',
  US_WEST_OREGON = 'Americas',
}

export enum AWSRegionCity {
  ASIA_PACIFIC_MUMBAI = 'Mumbai',
  ASIA_PACIFIC_OSAKA = 'Osaka',
  ASIA_PACIFIC_SEOUL = 'Seoul',
  ASIA_PACIFIC_SYDNEY = 'Sydney',
  ASIA_PACIFIC_TOKYO = 'Tokyo',
  CANADA_CENTRAL = 'Canada',
  EUROPE_FRANKFURT = 'Frankfurt',
  EUROPE_IRELAND = 'Dublin',
  EUROPE_LONDON = 'London',
  EUROPE_ZURICH = 'Zurich',
  MIDDLE_EAST_UAE = 'UAE',
  SOUTH_AMERICA_SAO_PAULO = 'Sao Paulo',
  US_EAST_NORTH_VIRGINIA = 'US East',
  US_EAST_2_OHIO = 'US East 2 - FedRAMP',
  US_WEST_OREGON = 'US West',
}

export enum AWSRegionName {
  ASIA_PACIFIC_MUMBAI = 'ap-south-1',
  ASIA_PACIFIC_OSAKA = 'ap-northeast-3',
  ASIA_PACIFIC_SEOUL = 'ap-northeast-2',
  ASIA_PACIFIC_SYDNEY = 'ap-southeast-2',
  ASIA_PACIFIC_TOKYO = 'ap-northeast-1',
  CANADA_CENTRAL = 'ca-central-1',
  EUROPE_FRANKFURT = 'eu-central-1',
  EUROPE_IRELAND = 'eu-west-1',
  EUROPE_LONDON = 'eu-west-2',
  EUROPE_ZURICH = 'eu-central-2',
  MIDDLE_EAST_UAE = 'me-central-1',
  SOUTH_AMERICA_SAO_PAULO = 'sa-east-1',
  US_EAST_NORTH_VIRGINIA = 'us-east-1',
  US_EAST_2_OHIO = 'us-east-2',
  US_WEST_OREGON = 'us-west-2',
}

export enum AWSRegionShortName {
  ASIA_PACIFIC_MUMBAI = 'Mumbai',
  ASIA_PACIFIC_OSAKA = 'Osaka',
  ASIA_PACIFIC_SEOUL = 'Seoul',
  ASIA_PACIFIC_SYDNEY = 'Sydney',
  ASIA_PACIFIC_TOKYO = 'Tokyo',
  CANADA_CENTRAL = 'Central',
  EUROPE_FRANKFURT = 'Frankfurt',
  EUROPE_IRELAND = 'Dublin',
  EUROPE_LONDON = 'London',
  EUROPE_ZURICH = 'Zurich',
  MIDDLE_EAST_UAE = 'UAE',
  SOUTH_AMERICA_SAO_PAULO = 'São Paulo',
  US_EAST_NORTH_VIRGINIA = 'Virginia',
  US_EAST_2_OHIO = 'Ohio',
  US_WEST_OREGON = 'Oregon',
}
